import { render, staticRenderFns } from "./NpsBar.vue?vue&type=template&id=b07c0546&scoped=true&"
import script from "./NpsBar.vue?vue&type=script&lang=js&"
export * from "./NpsBar.vue?vue&type=script&lang=js&"
import style0 from "./NpsBar.vue?vue&type=style&index=0&id=b07c0546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07c0546",
  null
  
)

export default component.exports